import React from "react";
import SkeletonCard from "./BasicSkeleton/SkeletonCard";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";

const CardContainerSkeleton = () => {
  return (
    <div className="market-place-skeleton">
      <div className="card-container w-100 ms-lg-4">
        <div className="card-list">
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard className="d-none d-md-block" />
          <SkeletonCard className="d-none d-md-block" />
          <SkeletonCard className="d-none d-md-block" />
          <SkeletonCard className="d-none d-md-block" />
          <SkeletonCard className="d-none d-md-block" />
        </div>
      </div>
    </div>
  );
};

export default CardContainerSkeleton;
